const recordId = value => String(value?._id || value || '');
// Display grouping only. Callers must enforce the original team's access rules first.
const belongsToOkrTeam = (record, team) => {
    if (!team || !record) return false;
    if (!team.isManagementGroup) return recordId(record.teamId) === recordId(team);
    if (record.pointOwnerType === 'virtual') return false;
    const owner = recordId(record.pointOwnerUserId || record.ownerId);
    return Boolean(owner) && (team.memberIds || []).some(member => recordId(member) === owner);
};
export { belongsToOkrTeam };
